import { useState, useEffect, useRef } from 'react';
import { apiClient } from '../../components/api/ApiClient';
import { Modal, Button, Form } from 'react-bootstrap';

const PERSON_TYPES = [
    { value: 1, label: 'حقیقی' },
    { value: 2, label: 'حقوقی' },
    { value: 3, label: 'مشارکت مدنی' },
    { value: 4, label: 'اتباع غیر ایرانی' },
];

function ProfileUsers() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [toast, setToast] = useState({ show: false, message: '' });
    const [modalError, setModalError] = useState('');

    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);


    const [showModal, setShowModal] = useState(false);
    const [modalMode, setModalMode] = useState('create');
    const [editingId, setEditingId] = useState(null);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);

    const tableRef = useRef(null);


    const initialFormState = {
        name: '',
        lastName: '',
        personType: 1,
        personId: '',
        personPostalCode: '',
        personEconomicNum: '',
        companyName: '',
        registrationNum: '',
        branchName: '',
        branchNum: '',
        province: '',
        city: '',
        street: '',
        pelak: '',
        phoneNum: '',
        mobileNum: '',
    };
    const [formData, setFormData] = useState(initialFormState);


    useEffect(() => {
        fetchUsers();
        fetchLocationData();
    }, []);

    useEffect(() => {
        if (toast.show) {
            const timer = setTimeout(() => setToast({ ...toast, show: false }), 5000);
            return () => clearTimeout(timer);
        }
    }, [toast.show]);

    const showToast = (message) => {
        setToast({ show: true, message });
    };

    useEffect(() => {
        if (!loading && users.length > 0 && window.jQuery && window.jQuery.fn.DataTable && tableRef.current) {
            if (window.jQuery.fn.DataTable.isDataTable(tableRef.current)) {
                window.jQuery(tableRef.current).DataTable().destroy();
            }
            const dataTable = window.jQuery(tableRef.current).DataTable({
                "dom": '<"row mb-3 text-dark"<"col-md-6"l><"col-md-6 search-label-after"f>><"row"<"col-sm-12"tr>><"row text-dark"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
                "language": {
                    "sEmptyTable": "هیچ داده‌ای در جدول وجود ندارد",
                    "sInfo": "نمایش _START_ تا _END_ از _TOTAL_ ردیف",
                    "sInfoEmpty": "نمایش ۰ تا ۰ از ۰ ردیف",
                    "sInfoFiltered": "(فیلتر شده از _MAX_ ردیف)",
                    "sInfoThousands": ",",
                    "sLengthMenu": "نمایش _MENU_ ردیف",
                    "sLoadingRecords": "در حال بارگذاری...",
                    "sProcessing": "در حال پردازش...",
                    "sSearch": "جستجو:",
                    "sZeroRecords": "هیچ ردیفی مطابق با جستجوی شما پیدا نشد",
                    "oPaginate": {
                        "sFirst": "اولین",
                        "sLast": "آخرین",
                        "sNext": "بعدی",
                        "sPrevious": "قبلی"
                    },
                    "oAria": {
                        "sSortAscending": ": فعال‌سازی برای مرتب‌سازی صعودی ستون",
                        "sSortDescending": ": فعال‌سازی برای مرتب‌سازی نزولی ستون"
                    }
                },
                "pagingType": "full_numbers",
                "searching": true,
                "lengthChange": true,
                "ordering": true,
                "info": true,
                "destroy": true
            });
            return () => {
                if (window.jQuery && window.jQuery.fn.DataTable.isDataTable(tableRef.current)) {
                    try { window.jQuery(tableRef.current).find('[data-bs-toggle="tooltip"]').tooltip('dispose'); } catch (e) {}
                    dataTable.destroy(false);
                }
            };
        }
    }, [users, loading]);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const data = await apiClient('/user-preferences/api/user-person/', { method: 'GET' });
            setUsers(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error('Error fetching users:', err);
            setError('خطا در دریافت لیست کاربران');
        } finally {
            setLoading(false);
        }
    };

    const fetchLocationData = async () => {
        try {
            const provData = await apiClient('/internal-network/api/location/?type=province', { method: 'GET' });
            if (provData && provData.provinces) setProvinces(provData.provinces);
            else if (Array.isArray(provData)) setProvinces(provData);
        } catch (err) {
            console.error('Error fetching location data', err);
        }
    };

    useEffect(() => {
        if (formData.province) {
            const fetchCities = async () => {
                try {
                    const cityData = await apiClient(`/account/api/cities/?province=${formData.province}`, { method: 'GET' });
                    if (cityData && cityData.cities) {
                        setCities(cityData.cities);
                    } else if (Array.isArray(cityData)) {
                        setCities(cityData);
                    } else {
                        setCities([]);
                    }
                } catch (err) {
                    console.error('Error fetching cities', err);
                    setCities([]);
                }
            };
            fetchCities();
        } else {
            setCities([]);
        }
    }, [formData.province]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePersonTypeChange = (e) => {
        setFormData(prev => ({
            ...prev,
            personType: parseInt(e.target.value),

        }));
    };

    const openCreateModal = () => {
        setModalError('');
        setFormData(initialFormState);
        setModalMode('create');
        setEditingId(null);
        setShowModal(true);
    };

    const openEditModal = (user) => {
        setFormData({
            name: user.name || '',
            lastName: user.lastName || '',
            personType: parseInt(user.personType) || 1,
            personId: user.personId || '',
            personPostalCode: user.personPostalCode || '',
            personEconomicNum: user.personEconomicNum || '',
            companyName: user.companyName || '',
            registrationNum: user.registrationNum || '',
            branchName: user.branchName || '',
            branchNum: user.branchNum || '',
            province: user.province || '',
            city: user.city || '',
            street: user.street || '',
            pelak: user.pelak || '',
            phoneNum: user.phoneNum || '',
            mobileNum: user.mobileNum || '',
        });
        setModalError('');
        setModalMode('edit');
        setEditingId(user.id);
        setShowModal(true);
    };

    const handleDeleteClick = (user) => {
        setDeleteTarget(user);
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        if (!deleteTarget) return;
        try {
            await apiClient('/user-preferences/api/user-person/', {
                method: 'DELETE',
                data: { id: deleteTarget.id }
            });
            fetchUsers();
            setShowDeleteModal(false);
            setDeleteTarget(null);
            setSuccess('کاربر با موفقیت حذف شد');
            setTimeout(() => setSuccess(null), 3000);
        } catch (err) {
            console.error('Error deleting user:', err);
            setError('خطا در حذف کاربر: ' + (err.message || 'Unknown error'));
        }
    };

    const handleSave = async () => {
        try {
            if (modalMode === 'create') {
                const duplicateCheck = users.find(u => {
                    if (formData.personType === 1 || formData.personType === 4) {
                        return String(u.personId || '').trim() === String(formData.personId || '').trim() && 
                               String(u.personId || '').trim() !== '';
                    } else if (formData.personType === 2 || formData.personType === 3) {
                        const hasNationalCodeMatch = String(u.personId || '').trim() === String(formData.personId || '').trim() && 
                                                     String(formData.personId || '').trim() !== '';
                        const hasEconomicCodeMatch = String(u.personEconomicNum || '').trim() === String(formData.personEconomicNum || '').trim() && 
                                                     String(formData.personEconomicNum || '').trim() !== '';
                        return hasNationalCodeMatch || hasEconomicCodeMatch;
                    }
                    return false;
                });

                if (duplicateCheck) {
                    setModalError('شخصی با این شناسه ملی، کد ملی یا کد اقتصادی قبلاً ثبت شده است');
                    return;
                }
            }

            let url = '/user-preferences/api/user-person/';
            let payload = { ...formData };
            let reqMethod = 'POST';
            if (modalMode === 'edit') {
                reqMethod = 'PUT';
                payload.personIden = editingId;
            }

            await apiClient(url, {
                method: reqMethod,
                data: payload
            });

            setShowModal(false);
            fetchUsers();
            setSuccess(modalMode === 'create' ? 'کاربر جدید با موفقیت ایجاد شد' : 'تغییرات با موفقیت ذخیره شد');
            setTimeout(() => setSuccess(null), 3000);
        } catch (err) {
            console.error('Error saving user:', err);
            if (err.message && err.message.includes('duplicate') || err.message && err.message.includes('تکراری')) {
                setModalError('شخصی با این شناسه ملی، کد ملی یا کد اقتصادی قبلاً ثبت شده است');
            } else {
                showToast('خطا در ذخیره اطلاعات: ' + (err.message || 'Unknown error'));
            }
        }
    };


    const renderSpecificFields = () => {
        const type = formData.personType;
        return (
            <>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">نام <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name || ''}
                            onChange={handleInputChange}
                            disabled={type === 2}
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">نام خانوادگی <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            name="lastName"
                            value={formData.lastName || ''}
                            onChange={handleInputChange}
                            disabled={type === 2}
                        />
                    </div>
                </div>

                {type === 1 && (
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label">کد ملی <span className="text-danger">*</span></label>
                            <input type="text" className="form-control" name="personId" value={formData.personId || ''} onChange={handleInputChange} />
                        </div>
                    </div>
                )}

                {type === 2 && (
                    <>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label">نام شرکت <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" name="companyName" value={formData.companyName || ''} onChange={handleInputChange} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">شناسه ملی <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" name="personId" value={formData.personId || ''} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label">شماره ثبت</label>
                                <input type="text" className="form-control" name="registrationNum" value={formData.registrationNum || ''} onChange={handleInputChange} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">کد اقتصادی</label>
                                <input type="text" className="form-control" name="personEconomicNum" value={formData.personEconomicNum || ''} onChange={handleInputChange} />
                            </div>
                        </div>
                    </>
                )}

                {(type === 3 || type === 4) && (
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label">{type === 4 ? 'کد فراگیر/گذرنامه' : 'شناسه مشارکت'}</label>
                            <input type="text" className="form-control" name="personId" value={formData.personId || ''} onChange={handleInputChange} />
                        </div>
                    </div>
                )}
            </>
        );
    };

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card stretch stretch-full">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h5 className="card-title">اشخاص</h5>
                        <button className="btn btn-success" onClick={openCreateModal}>
                            اضافه کردن شخص جدید
                        </button>
                    </div>
                    {success && <div className="alert alert-success m-3">{success}</div>}
                    {error && <div className="alert alert-danger m-3">{error}</div>}
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-hover" ref={tableRef}>
                                <thead>
                                    <tr>
                                        <th>نام</th>
                                        <th>نام خانوادگی</th>
                                        <th>نام بنگاه اقتصادی</th>
                                        <th>نوع</th>
                                        <th>کد ملی/کد اتباع خریدار</th>
                                        <th>کد پستی</th>
                                        <th>کد اقتصادی</th>
                                        <th>نام کاربری شبکه ارسین</th>
                                        <th className="text-end">عملیات</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {users.length > 0 ? (
                                        users.map((user) => (
                                            <tr key={user.id} className="single-item">
                                                <td>{user.name || '-'}</td>
                                                <td>{user.lastName || '-'}</td>
                                                <td>{user.companyName || '-'}</td>
                                                <td>
                                                    {PERSON_TYPES.find(t => t.value === parseInt(user.personType))?.label || user.personType}
                                                </td>
                                                <td>{user.personId || '-'}</td>
                                                <td>{user.personPostalCode || '-'}</td>
                                                <td>{user.personEconomicNum || '-'}</td>
                                                <td>{user.person_username || '-'}</td>
                                                <td>
                                                    <div className="hstack gap-2 justify-content-end">
                                                        <button className="btn btn-sm btn-soft-primary" onClick={() => openEditModal(user)}>
                                                            <i className="feather feather-edit-3"></i>
                                                        </button>
                                                        <button className="btn btn-sm btn-soft-danger" onClick={() => handleDeleteClick(user)}>
                                                            <i className="feather feather-trash-2"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center py-4">
                                                {loading ? 'در حال بارگذاری...' : 'هیچ شخصی یافت نشد.'}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{modalMode === 'create' ? 'مشخصات شخص جدید' : 'ویرایش شخص'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalError ? (
                        <div className="alert alert-danger mb-3" role="alert">
                            {modalError}
                        </div>
                    ) : null}
                    <Form>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label">نوع شخص <span className="text-danger">*</span></label>
                                <select
                                    className="form-select"
                                    name="personType"
                                    value={formData.personType}
                                    onChange={handlePersonTypeChange}
                                >
                                    {PERSON_TYPES.map(type => (
                                        <option key={type.value} value={type.value}>{type.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {renderSpecificFields()}

                        <hr />
                        <h6>اطلاعات تماس و آدرس</h6>

                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label">استان</label>
                                <select className="form-select" name="province" value={formData.province} onChange={(e) => {
                                    handleInputChange(e);
                                    setFormData(prev => ({ ...prev, city: '' }));
                                }}>
                                    <option value="">انتخاب کنید</option>
                                    {provinces.length > 0 ? provinces.map(p => (
                                        <option key={p.id || p.code} value={p.id || p.code}>{p.name}</option>
                                    )) : <option value="3">خراسان رضوی (مثال)</option>}
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">شهر</label>
                                <select className="form-select" name="city" value={formData.city} onChange={handleInputChange} disabled={!formData.province}>
                                    <option value="">انتخاب کنید</option>
                                    {cities.length > 0 ? cities.map(c => (
                                        <option key={c.id || c.code} value={c.id || c.code}>{c.name}</option>
                                    )) : formData.province ? <option value="">در حال بارگذاری...</option> : <option value="">ابتدا استان را انتخاب کنید</option>}
                                </select>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label">کد شعبه</label>
                                <input type="text" className="form-control" name="branchNum" value={formData.branchNum || ''} onChange={handleInputChange} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">نام شعبه</label>
                                <input type="text" className="form-control" name="branchName" value={formData.branchName || ''} onChange={handleInputChange} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-12">
                                <label className="form-label">خیابان</label>
                                <input type="text" className="form-control" name="street" value={formData.street || ''} onChange={handleInputChange} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">پلاک</label>
                                <input type="text" className="form-control" name="pelak" value={formData.pelak || ''} onChange={handleInputChange} />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">کد پستی <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" name="personPostalCode" value={formData.personPostalCode || ''} onChange={handleInputChange} />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">تلفن ثابت <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" name="phoneNum" value={formData.phoneNum || ''} onChange={handleInputChange} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label">شماره همراه <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" name="mobileNum" value={formData.mobileNum || ''} onChange={handleInputChange} />
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setShowModal(false)}>
                        لغو
                    </Button>
                    <Button variant="success" onClick={handleSave}>
                        {modalMode === 'create' ? 'ثبت' : 'ذخیره تغییرات'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Body className="text-center py-4">
                    <h5>آیا از حذف این شخص مطمئن هستید؟</h5>
                    <p className="text-muted">این عملیات غیرقابل بازگشت است.</p>
                    <div className="d-flex justify-content-center gap-2 mt-4">
                        <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>خیر</Button>
                        <Button variant="danger" onClick={confirmDelete}>بله، حذف شود</Button>
                    </div>
                </Modal.Body>
            </Modal>

            {toast.show && (
                <div aria-live="polite" aria-atomic="true" className="position-fixed w-100 p-3" style={{ zIndex: 9999999, top: 0, right: 0 }}>
                    <div className="toast-container position-absolute p-3" id="toastPlacement" style={{ top: 0, left: 0 }}>
                        <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true">
                            <div className="toast-header" style={{ direction: 'rtl' }}>
                                <img src="/assets/images/redesigned.png" className="rounded ms-2" alt="..." width="20" />
                                <strong className="me-auto ms-2">پیام سیستم</strong>
                                <button type="button" className="btn-close" onClick={() => setToast({ ...toast, show: false })}></button>
                            </div>
                            <div className="toast-body">
                                {toast.message}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ProfileUsers;